<script>
  export let idUnico = 'accordion';
  export let semlegenda = false;
  export let comImagem = false;
  export let width_content = '100%';
  export let content;

  let root;

  let tabs = [];
  // let tab = [];

  let comandoBegin;
  let comandoEnd;
  let comandoFrase;

  let hasLegenda;
  let legenda;

  // italico
  let italicoBegin;

  // accordion com imagens
  let hasImage;
  let url = [];
  let img_source = 'Imagem disponível em:';

  hasImage = content.indexOf('[img]');
  if (hasImage != -1) {
    content = content.substring('[img]'.length, content.length);
  }

  hasLegenda = content.indexOf('<legenda>');
  if (hasLegenda != -1) {
    legenda = content.substring(
      hasLegenda + '<legenda>'.length,
      content.length - '</legenda>'.length
    );
  }

  comandoBegin = content.search('<comando>');
  if (comandoBegin != -1) {
    comandoEnd = content.search('</comando>');
    if (comandoEnd != -1) {
      comandoFrase = content.substring(comandoBegin + 9, comandoEnd);
      content = content.substring(comandoEnd + 10, content.length);
    }
  }

  italicoBegin = content.search('accountability');
  if (italicoBegin != -1) {
    content = content.replace(
      content.substring(italicoBegin, italicoBegin + 'accountability'.length),
      '<i>' + content.substring(italicoBegin, italicoBegin + 'accountability'.length) + '</i>'
    );
  }

  let contentAux = '';
  tabs = content.split(';;').slice(0, -1);

  tabs.forEach((el, index) => {
    if (el.indexOf(img_source) != -1) {
      url[index] = el.substring(el.indexOf(img_source) + img_source.length, el.length);
    }
  });

  import { onMount } from 'svelte';
  //ACCORDION LOADER
  onMount(async () => {
    if (hasImage != -1) {
      root.style.setProperty('--padding_content', '0px 0px 0px 0px');
      root.style.setProperty('--margin_content', '-32px');
      root.style.setProperty('--shadow_button', 'drop-shadow(0 2px 2px rgba(0, 0, 0, 0.4))');
      root.style.setProperty('--width_content', '90%');
      root.style.setProperty('--border_radius', '0 0 10px 10px');
      // root.style.setProperty('--margin_bottom', '0px');
      // root.style.setProperty('--width_content_mob', '86%');
    } else {
      root.style.setProperty('--padding_content', '15px 30px 30px 30px');
      root.style.setProperty('--margin_content', '-32px');
      root.style.setProperty('--margin_bottom', '30px');
      root.style.setProperty('--shadow_button', 'drop-shadow(0 3px 5px rgba(0, 0, 0, 0.0))');
      root.style.setProperty('--border_radius', '0 0 10px 10px');
      root.style.setProperty('--width_content', '90%');
      root.style.setProperty('--width_content_mob', '90%');
    }

    // const bw = j$(`.button-wrapper`);

    // if (flag) {
    document.querySelectorAll(`#${idUnico} #accordion > div`).forEach((element, i) => {
      let button = element.querySelector('.button');
      let content = element.querySelector('.content');
      let contentId = `${idUnico}-content-${i}`;
      let labelId = `${idUnico}-button-${i}`;
      button.setAttribute('id', labelId);
      button.setAttribute('data-toggle', 'collapse');
      button.setAttribute('data-target', `#${contentId}`);
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', contentId);
      content.setAttribute('id', contentId);
      content.setAttribute('aria-labelledby', labelId);
      content.setAttribute('data-parent', `#${idUnico} #accordion`);
      content.className = 'content collapse';
      // if (i === 0) {
      //   content.className = 'content collapse show';
      //   button.setAttribute('aria-expanded', 'true');
      // }
    });
    // }

    // tabs.forEach((element, index) => {
    //   if (element.trim() != '') {
    //     tab[index] = element.split('::');
    //   }
    // });
  });
</script>

<div class="container" id={idUnico} bind:this={root}>
  <p class="comando">
    {@html comandoFrase}
  </p>
  <div id="accordion">
    {#each tabs as tab, index}
      <div>
        <div class="bkg-wrapper">
          <div class="button-shadow" />
          <div class="button-wrapper">
            <div class="button">
              <h3>{@html tab.split('::')[0]}</h3>
            </div>
          </div>
          <div class="button-wrapper">
            <div class="content">
              <div>
                {#if hasImage == -1}
                  {@html tab.split('::')[1]}
                {:else}
                  <img src={'./assets/images/modulo/accordion_u2_' + (index + 1) + '.jpg'} alt="" />
                {/if}
              </div>
            </div>
          </div>
        </div>
      </div>
    {/each}
  </div>
  <div class="justify-content-center">
    {#if hasLegenda != -1}
      <div class="legenda-wrapper">
        <div class="legenda">
          {@html legenda}
        </div>
      </div>
    {/if}
  </div>
</div>

<style>
  p.comando {
    padding: 0;
    margin: 0 0 calc(1.5rem) 0;
  }
  #accordion {
    position: relative;
    padding-top: 12px;
  }
  #accordion > :global(div.button),
  #accordion > :global(div.content) {
    width: 100%;
    margin: 25px 0 55px 0;
    margin: 0px 0 0px 0;
    transform-style: preserve-3d;
  }
  #accordion :global(.button-wrapper) {
    display: flex;
    justify-content: center;
  }
  #accordion > div:nth-child(odd) :global(.button-shadow) {
    background: var(--AMARELO_ESCURO);
  }
  #accordion :global(.button-shadow) {
    width: 100%;
    height: 20px;
    clip-path: polygon(5% 0%, 5% 100%, 2.5% 100%);
    background: var(--VERDE);
    position: absolute;
    margin-top: -24px;
    margin-left: -2px;
  }
  #accordion > div:nth-child(odd) :global(.bkg-wrapper) {
    border: 2px dashed var(--AMARELO_ESCURO);
  }
  #accordion :global(.bkg-wrapper) {
    --Gradientes-Degrad-principal-inv: linear-gradient(to left, #33cfb9, #b62ca2);
    --Infogrficos-Cinza: #e1e4e5;
    --Infogrficos-Cinza: #fff;
    border: 2px dashed var(--VERDE);
    border-radius: 10px;
    margin-top: 10px;
  }
  #accordion > div:nth-child(odd) :global(.button > h3) {
    color: var(--PRETO);
  }
  #accordion > div:nth-child(odd) :global(.button) {
    background: var(--AMARELO);
  }
  #accordion :global(.button) {
    all: unset;
    cursor: pointer;
    width: 90%;
    background: var(--VERDE_CLARO);
    border-radius: 0 0 13px 13px;
    font-weight: 700;
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 5;
    margin-top: -24px;
    margin-bottom: 20px;

    /* transform: translateZ(0.1px); */
    /* border-left: 2px solid var(--COR_BRANCO);
    border-right: 2px solid var(--COR_BRANCO); */
  }

  #accordion > div:nth-child(odd) :global(.button):hover {
    /* background: #e8c1f3; */
  }

  #accordion :global(.button):hover {
    /* background: #6a4f91; */
  }

  #accordion :global(.button > h3) {
    font-family: var(--FONTE_INTER);
    font-weight: 600;
    font-size: 19px;
    padding: 15px 30px;
    color: var(--BRANCO);
  }
  #accordion :global(.content) {
    transform-style: preserve-3d;
    /* transform: translateZ(-0.1px); */
    width: 90%;
    width: var(--width_content);
    margin-top: var(--margin_content);
    margin-top: -32px;
    margin-bottom: var(--margin_bottom);
    margin-bottom: 20px;
    border-radius: 0 0 15px 15px;
  }
  #accordion > div:nth-child(odd) :global(.content > div) {
    background: var(--AMARELO);
    /* color: var(--COR_MOD_PRI); */
    font-weight: 500;
    color: var(--PRETO);
  }
  #accordion :global(.content > div) {
    color: var(--BRANCO);
    transform-style: preserve-3d;
    /* transform: translateZ(-0.1px); */
    border-radius: 0 0 15px 15px;
    padding: var(--padding_content);
    position: relative;
    /* filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.1)); */
    font-size: 18px;
    background: var(--VERDE_CLARO);
  }

  #accordion :global(.content > div img) {
    width: 100%;
    border-radius: var(--border_radius);
    /* filter: grayscale(1); */
    /* border: 2px solid white; */
  }

  #accordion :global(.button > i) {
    margin: 20px 25px;
  }

  #accordion :global(.button i path) {
    fill: var(--COR_MODULO);
    fill: transparent;
  }

  #accordion > div:nth-child(odd) :global(.button[aria-expanded='true']) {
    /* background: #e8c1f3; */
  }
  #accordion :global(.button[aria-expanded='true']) {
    /* background: #6a4f91; */
    /* border-radius: 0 0 15px 15px; */
    /* border-radius: 0; */
    /* filter: drop-shadow(0 3px 5px rgba(0, 0, 0, 0.5)); */
    filter: var(--shadow_button);
  }
  #accordion :global(.button[aria-expanded='true'] > h3) {
    /* color: #eee; */
  }
  #accordion :global(.button[aria-expanded='true'] i) {
    transform: rotate(-90deg);
  }

  /* Prof. Luciano */
  #accordion > :global(div:not(:last-child)) {
    margin-bottom: 45px;
  }
  /* Fim Prof. Luciano */
  .legenda-wrapper {
    position: relative;
    border-left: 4px dotted var(--COR_VERDE);
    padding: 0 0 0 10px;
    margin: 10px 0 0 0;
    margin: 0 0 0 0;
    font-size: 16px;
    font-family: var(--FONT_BARLOW);
  }

  .legenda {
    font-size: 14px;
  }

  .legenda :global(div:first-child) {
    font-size: 16px;
    margin-bottom: 4px;
  }

  @media (max-width: 767px) {
    #accordion :global(.button > h3) {
      padding: 15px 20px;
      font-size: 18px;
    }

    .container {
      /* background: red; */
      /* padding-left: 0px; */
      /* padding-right: 0px; */
    }

    #accordion {
      /* background: #f0f0f0; */
    }

    #accordion :global(.button) {
      border-radius: 0 0 15px 15px;
      width: 90%;
    }

    #accordion :global(.content > div) {
      border-radius: 0 0 15px 15px;
      padding: 15px 20px 20px 20px;
      font-size: 18px;
    }

    #accordion :global(.content) {
      /* width: 86%; */
      /* margin-top: -40px; */
      width: var(--width_content_mob);
    }

    #accordion :global(.button-shadow) {
      /* clip-path: polygon(7% 0%, 93% 0%, 97.5% 100%, 2.5% 100%); */
      clip-path: polygon(5.5% 0%, 7% 100%, 2% 100%);
    }

    #accordion :global(.bkg-wrapper) {
      /* background: #f0f0f0; */
    }
  }
</style>
